function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import MuiTypography from "@mui/material/Typography";
// @limitless
import { useTranslation } from "@limitless/common/hooks";
const Typography = ({
  children,
  translationSubstitutes = "",
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(MuiTypography, _extends({
    color: "primary.dark"
  }, rest), t(children, translationSubstitutes));
};
Typography.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.number]).isRequired,
  translationSubstitutes: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};
export default Typography;